import BigNumber from "bignumber.js"

// this function is broken, we need to use BN math here
export const toFixedRoundDown = (value: string, decimalPlaces: number) => {
  const bnValue = new BigNumber(value).toFixed(decimalPlaces, 1)
  return bnValue
}
